import {Card, CardActionArea, CardContent, Checkbox, Grid, Typography} from "@mui/material";
import {Tag} from "~/apps/core/ui/Tag";
import {formatWeight, humanizeCargoDirection, humanizeCargoType} from "~/apps/packages/auto-visits/utils";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import React from "react";
import {SelectableCard} from "~/apps/core/ui/SelectableCard";


export type CargoSelectDialogItemProps = {
    cargo: any
    selected?: boolean
    onClick?: () => void
}


export const CargoSelectDialogItem = React.memo<CargoSelectDialogItemProps>(({selected, cargo, onClick}) => {
    return (
        <SelectableCard
            onClick={onClick}
            selected={selected}
            title={cargo.name}
        >
            <Grid container wrap="nowrap" spacing="8px">
                <Grid item>
                    <Tag>
                        {humanizeCargoDirection(cargo.direction)}
                    </Tag>
                </Grid>
                {cargo.type && (
                    <Grid item>
                        <Tag>
                            {humanizeCargoType(cargo.type)}
                        </Tag>
                    </Grid>
                )}
            </Grid>
            <Grid container wrap="nowrap"
                  justifyContent="space-between">
                <Grid item container direction="column" width="auto">
                    <TypographyWithLabel label="Наряд">
                        {cargo.order?.number || <>&ndash;</>}
                    </TypographyWithLabel>
                </Grid>
                <Grid item container direction="column" width="auto">
                    <TypographyWithLabel label="Склад">
                        {cargo.storageName || <>&ndash;</>}
                    </TypographyWithLabel>
                </Grid>
                <Grid item container direction="column" width="auto">
                    <TypographyWithLabel label="Вес / Мест">
                        {cargo.weight ? formatWeight(cargo.weight) : <>&ndash;</>} / {cargo.quantity || <>&ndash;</>}
                    </TypographyWithLabel>
                </Grid>
            </Grid>
        </SelectableCard>
    )
})